import { Radio, ConfigProvider } from "antd";

export default function RadioButtonGroupComponent({ purpose, selectedValue, onChangeHandler }) {
  const onChangeOption = (e) => {
    onChangeHandler(purpose, e.target.value);
  };

  return (
    <div className="flex gap-6">
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: "#572D86",
            colorPrimaryBorder: "#572D86",
            colorPrimaryHover: "#572D86",
            controlOutline: "#572D86",
            colorBorder: "#572D86",
          },
        }}
      >
        <Radio.Group onChange={onChangeOption} value={selectedValue}>
          <Radio value="On" className="mr-4">
            On
          </Radio>
          <Radio value="Off">
            Off
          </Radio>
        </Radio.Group>
      </ConfigProvider>
    </div>
  );
}
